import React from 'react';
import { Navigate } from 'react-router-dom';
// 🛑 IMPORTANT : Assurez-vous que le chemin ci-dessous est correct par rapport à ce fichier.
import { useAuth } from './AuthContext'; 

const ProtectedRoute = ({ children }) => {
    // Utiliser l'état du contexte centralisé, qui gère sessionStorage
    const { isLoggedIn, isLoading } = useAuth(); 

    // 1. Si nous sommes en cours de chargement (vérification de sessionStorage au démarrage de l'app)
    if (isLoading) {
        // Affiche un écran de chargement pour éviter de rediriger un utilisateur déjà connecté (via sessionStorage)
        return (
            <div className="min-h-screen flex items-center justify-center text-gray-700 bg-gray-50">
                Vérification de la session...
            </div>
        );
    }

    // 2. Si l'utilisateur n'est PAS connecté après la vérification
    if (!isLoggedIn) {
        // Redirige vers la page de connexion (path="/")
        return <Navigate to="/" replace />;
    }

    // 3. Si l'utilisateur est connecté et le chargement est terminé
    return children;
};

export default ProtectedRoute;